import { render, staticRenderFns } from "./dayinbangdan.vue?vue&type=template&id=6748c132&scoped=true&"
import script from "./dayinbangdan.vue?vue&type=script&lang=js&"
export * from "./dayinbangdan.vue?vue&type=script&lang=js&"
import style0 from "./dayinbangdan.vue?vue&type=style&index=0&id=6748c132&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6748c132",
  null
  
)

export default component.exports